import makeCrudModule from '@/factories/CrudModelFactory';
import landingpagesService from '@/services/deployments';

export default makeCrudModule({
    service: landingpagesService,
    dateConvert: [
        'created_at', 'updated_at'
    ]
});
